// Composant pour injecter du JSON-LD (données structurées Schema.org) dans le <head>
// Utilisé pour les rich results Google : LocalBusiness, Article, FAQ, BreadcrumbList, ImageObject

import { useEffect } from 'react';

export default function JsonLd({ data }) {
  useEffect(() => {
    const id = 'json-ld-' + Math.random().toString(36).slice(2);
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = id;
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);

    return () => {
      const el = document.getElementById(id);
      if (el) el.remove();
    };
  }, [JSON.stringify(data)]);

  return null;
}
